import React from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useCallback } from 'react';

// Hook personnalisé pour remplacer withRouter
export const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const goForward = useCallback(() => {
    navigate(1);
  }, [navigate]);

  const push = useCallback((path, state = null) => {
    navigate(path, { state });
  }, [navigate]);

  const replace = useCallback((path, state = null) => {
    navigate(path, { replace: true, state });
  }, [navigate]);

  return {
    navigate,
    location,
    params,
    goBack,
    goForward,
    push,
    replace,
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
    state: location.state
  };
};

// Maintenir la compatibilité avec l'ancien withRouter pour les composants legacy
export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const router = useRouter();
    
    return (
      <Component
        navigate={router.navigate}
        location={router.location}
        params={router.params}
        router={router}
        {...props}
      />
    );
  };
  
  return Wrapper;
};